<app-modal>
    <ng-container title>
        {{ 'FEATURES.AGREEMENTS.RENEGOTIATE.MODAL_TITLE' | translate }}
    </ng-container>

    <ng-container body>
        <p>{{ 'FEATURES.AGREEMENTS.RENEGOTIATE.MODAL_DESCRIPTION' | translate }}</p>

        <button type="button" class="read-more-toggle" (click)="toggleExpanded()">
            <span>{{
                (expanded ? 'FEATURES.AGREEMENTS.RENEGOTIATE.READ_LESS' : 'FEATURES.AGREEMENTS.RENEGOTIATE.READ_MORE')
                    | translate
            }}</span>
            <span class="material-symbols-rounded" aria-hidden="true">{{
                expanded ? 'expand_less' : 'expand_more'
            }}</span>
        </button>

        <div *ngIf="expanded" class="extended-info">
            <span [innerHTML]="'FEATURES.AGREEMENTS.RENEGOTIATE.EXTENDED_INFO' | translate"></span>
        </div>
    </ng-container>

    <ng-container footer>
        <button type="button" class="secondary" (click)="closeModal()">
            {{ 'BUTTONS.CANCEL' | translate }}
        </button>
        <button type="button" class="primary" (click)="send()" [class.loading]="loading" [disabled]="loading">
            {{ 'BUTTONS.SEND' | translate }}
        </button>
    </ng-container>
</app-modal>
